import * as React from 'react';
import Text from 'design-system/Text';
import ProgressCard from 'features/invest/components/InvestOnboardingFunnel/ProgressCard';
import { formatDateForItem } from 'utils/formatting';
const CollectingFromBankCard = ({ hasCollectedPayment, paymentCollectionDate, }) => (<ProgressCard lightBg noTextDecoration alwaysShowTimeline alwaysShowChildren completed={hasCollectedPayment} isActiveStep={!hasCollectedPayment} title={hasCollectedPayment ? 'Collected from bank' : 'Collecting from bank'} timeInfo={paymentCollectionDate ? formatDateForItem(new Date(paymentCollectionDate)) : undefined}>
    <Text TextThin-14 Secondary>
      {hasCollectedPayment
        ? 'The autosave amount has been collected from your bank account.'
        : 'We’re collecting the payment. This usually takes 1–2 working days.'}
    </Text>
  </ProgressCard>);
export default React.memo(CollectingFromBankCard);
